import * as types from '@/store/mutation-types'
import apolloClient from '@/api/apollo'
import indicatorsClient from '@/api/indicators'

import VEHICLES_QUERY from '@/graphql/queries/Reports/Vehicles.graphql'
import EVENTS_QUERY from '@/graphql/queries/Reports/Events.graphql'
import PAGINATED_EVENTS_QUERY from '@/graphql/queries/Reports/PaginatedEvents.graphql'
import EVENTS_COUNT_QUERY from '@/graphql/queries/Reports/EventsCount.graphql'

const module = {
  namespaced: true,
  state: {
    indicators: [],
    vehicles: [],
    events: [],
    totalEvents: 0
  },
  getters: {
    vehicles: state => state.vehicles,
    events: state => state.events,
    totalEvents: state => state.totalEvents,
    kilometersTraveled: state => state.kilometersTraveled,
    timeOn: state => state.timeOn,
    timeOff: state => state.timeOff,
    speedings: state => state.speedings,
    averageSpeed: state => state.averageSpeed
  },
  mutations: {
    [types.SET_INDICATORS] (state, { indicators }) {
      state.indicators = indicators
    },
    setVehicles (state, vehicles) {
      state.vehicles = vehicles
    },
    setEvents (state, events) {
      state.events = events
    },
    setTotalEvents (state, totalEvents) {
      state.totalEvents = totalEvents
    }
  },
  actions: {
    async fetchVehicles ({ commit }) {
      const result = await apolloClient.query({
        query: VEHICLES_QUERY
      })
      const vehicles = result.data.fetchVehicles
      commit('setVehicles', vehicles)
    },
    async fetchEvents ({ commit }, { vehicleId, startDate, finishDate }) {
      const result = await apolloClient.query({
        query: EVENTS_QUERY,
        variables: {
          vehicleId,
          startDate,
          finishDate
        }
      })
      const events = result.data.fetchEventsByVehicleAndDate
      commit('setEvents', events)
    },
    async fetchPaginatedEvents ({ commit }, { vehicleId, startDate, finishDate, page, rowsPerPage }) {
      const result = await apolloClient.query({
        query: PAGINATED_EVENTS_QUERY,
        variables: {
          vehicleId,
          startDate,
          finishDate,
          page,
          rowsPerPage
        }
      })
      const events = result.data.fetchPaginatedEventsByVehicleAndDate
      commit('setEvents', events)
    },
    async countEvents ({ commit }, { vehicleId, startDate, finishDate }) {
      const result = await apolloClient.query({
        query: EVENTS_COUNT_QUERY,
        variables: {
          vehicleId,
          startDate,
          finishDate
        }
      })
      const totalEvents = result.data.countEventsByVehicleAndDate.count
      commit('setTotalEvents', totalEvents)
    },
    async fetchIndicators ({ commit }, { vehicleId, mark, reference, startDate, finishDate }) {
      const indicators = await indicatorsClient.fetchIndicators({
        vehicleId,
        mark,
        reference,
        startDate,
        finishDate
      })
      commit(types.SET_INDICATORS, { indicators })
    },
    downloadSpreadsheet ({ commit }, { vehicleId, startDate, finishDate }) {
      return indicatorsClient.downloadSpreadsheet({
        vehicleId,
        startDate,
        finishDate
      })
    },
    downloadCsv ({ commit }, { vehicleId, startDate, finishDate }) {
      return indicatorsClient.downloadCsv({
        vehicleId,
        startDate,
        finishDate
      })
    }
  }
}

export default module



// WEBPACK FOOTER //
// ./src/store/modules/reports/index.js